module.exports = __webpack_public_path__ + "img/hr-heated-corner-down-left-2.7b1021e9.png";